export default "__VITE_ASSET__35d5cee3__"